module.exports = __webpack_public_path__ + "20250721160708/img/yue.2f25255c.png";